export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const USER_PRIVATE_DATA_TABLE = process.env.REACT_APP_USER_PRIVATE_DATA_TABLE || "user_private_data";
export const USER_PROMPTS_TABLE = process.env.REACT_APP_USER_PROMPTS_TABLE || "user_prompts";
export const ACCESS_REQUESTS_TABLE = process.env.REACT_APP_ACCESS_REQUESTS_TABLE || "user_access_requests";
export const ACTIVE_SESSIONS_TABLE = process.env.REACT_APP_ACTIVE_SESSIONS_TABLE || "user_active_sessions";
export const SINGLE_SESSION_ENFORCED = String(process.env.REACT_APP_SINGLE_SESSION_ENFORCED || "false").trim().toLowerCase() === "true";
export const STARTER_USER_ID = (process.env.REACT_APP_STARTER_USER_ID || "").trim();
export const DEMO_EMAILS = String(process.env.REACT_APP_DEMO_EMAILS || "demo@cardioradio.org")
  .split(",")
  .map((entry) => entry.trim().toLowerCase())
  .filter(Boolean);
export const DEFAULT_AI_PROVIDER = String(process.env.REACT_APP_AI_PROVIDER || "openai").trim().toLowerCase() === "anthropic"
  ? "anthropic"
  : "openai";
export const OPENAI_MODEL = process.env.REACT_APP_OPENAI_MODEL || "gpt-5.4-mini";
export const ANTHROPIC_MODEL = process.env.REACT_APP_ANTHROPIC_MODEL || "claude-sonnet-4-6";

const DEFAULT_AI_ENDPOINT = "/api/beurteilung";
const rawAiEndpoint = String(process.env.REACT_APP_AI_BEURTEILUNG_ENDPOINT || "").trim();
const isExternalAiEndpoint = /^https?:\/\//i.test(rawAiEndpoint);

if (process.env.NODE_ENV === "production" && isExternalAiEndpoint) {
  throw new Error("REACT_APP_AI_BEURTEILUNG_ENDPOINT must be same-origin in production.");
}

export const AI_BEURTEILUNG_ENDPOINT =
  rawAiEndpoint || DEFAULT_AI_ENDPOINT;

export const SYSTEM_PROMPT = `Du bist ein erfahrener Facharzt für Radiologie mit jahrelanger Erfahrung in der Befundung von bildgebenden Untersuchungen.

Der Benutzer gibt dir einen radiologischen Befund mit folgenden Angaben:
- Klinische Angaben (Vorgeschichte, Symptome)
- Fragestellung (was soll beantwortet werden)
- Modalität (CT, MRT 1,5T oder MRT 3T)
- Körperregion
- Befund (bildmorphologische Beschreibung)

Deine Aufgabe ist es, daraus eine präzise, klinisch korrekte "Beurteilung" zu formulieren.

Regeln:
- Klares, präzises medizinisches Deutsch
- Beantworte die Fragestellung direkt
- Fasse die wichtigsten Befunde zusammen und ordne sie klinisch ein
- Nenne die wahrscheinlichste Diagnose oder Differentialdiagnosen
- Gib ggf. Empfehlungen für weiteres Procedere
- 3-6 Sätze, Fließtext, radiologischer Stil
- Beginne NICHT mit "Beurteilung:"

Antworte NUR mit der Beurteilung, ohne Präambel oder Erklärungen.`;

export const MODALITIES = ["CT", "MRT 1,5", "MRT 3"];

export const MODALITY_PREFILL = {
  "CT": "Gerät: Durchführung der Untersuchung am Canon Aquilion One Genesis (320 Zeilen).",
  "MRT 1,5": "Gerät: Philips Ingenia Ambition X, 1,5 Tesla",
  "MRT 3": "Gerät: Philips Multi-Transmit, 3 Tesla",
};

export const RESOURCE_LINKS = [
  { name: "Radiology Assistant", url: "https://radiologyassistant.nl" },
  { name: "ConRad", url: "https://academy.mevis.de/drg/" },
  { name: "MSK MRI Atlas Stanford", url: "http://xrayhead.com" },
  { name: "RadioGraphics", url: "https://pubs.rsna.org/journal/radiographics" },
  { name: "Radiopaedia", url: "https://radiopaedia.org" },
  { name: "OpenEvidence", url: "https://openevidence.com" },
  { name: "RadioSurf", url: "https://radiosurf.elearning.aum.iml.unibe.ch/htmls/radthorax.html?radiosurf|radthorax" },
  { name: "Imaios", url: "https://www.imaios.com/en" },
];

export const DARK = {
  bg: "#000000",
  bgSecondary: "#111111",
  bgTertiary: "#1a1a1a",
  text: "#e2e8f0",
  textSecondary: "#8896a8",
  textTertiary: "#4a5568",
  border: "#2d2d2d",
  borderSecondary: "#3d3d3d",
  success: "#48bb78",
  danger: "#fc8181",
  warning: "#f6ad55",
  info: "#63b3ed",
};

export const LIGHT = {
  bg: "#ffffff",
  bgSecondary: "#f7f8fa",
  bgTertiary: "#eef0f3",
  text: "#1a202c",
  textSecondary: "#4a5568",
  textTertiary: "#a0aec0",
  border: "#e2e8f0",
  borderSecondary: "#cbd5e0",
  success: "#276749",
  danger: "#c53030",
  warning: "#c05621",
  info: "#2b6cb0",
};
